(function () {
  "use strict";

  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1",
      },
    ],
    (error) => {
      if (error) {
        throw error;
      }

      document.dispatchEvent(new CustomEvent("consentCustomer"));
    }
  );

  /* --- Section: Header */
  class Header extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var self = this;
      this.start, this.end;
      this.namespace = ".header";
      window.metas.page.a = "#metas_page";
      this.sectionId = this.dataset.sectionId;
      this.parentHeader = this.closest("#shopify-header-section");
      this.container = this.closest(".header");
      this.menuA = this.querySelector("[data-menu-a]");
      this.menuB = this.querySelector("[data-menu-b]");
      this.insetA = 0;
      this.insetB = 0;
      this.menuSections = document.querySelector(".menu-section");
      this.menuHamburger =
        this.menuSections.id === "shopify-section-header-line"
          ? this.querySelector("[data-menu-a] .menu-hamburger")
          : this.querySelector(".menu-hamburger");
      this.menuLinks = this.querySelectorAll(".header__menu .header__link");
      this.announceBar = document.querySelector(".announce_bar");
      this.menuLinks = this.querySelectorAll(".header__menu .header__link");

      if (this.menuA) {
        this.initHamburger();
      }

      if (this.menuSections) {
        requestAnimationFrame(function () {
          self.initMenu();
        });

        document.addEventListener("shopify:section:load", function (e) {
          if (self.querySelector(`#${e.target.id}`)) {
            window.scrollTo(0, 0);
          }

          if (self.menuA) {
            self.menuSections = document.querySelector(".menu-section");
            self.menuHamburger =
              self.menuSections.id === "shopify-section-header-line"
                ? self.querySelector("[data-menu-a] .menu-hamburger")
                : self.querySelector(".menu-hamburger");
            self.initHamburger();
          }

          self.initMenu();
        });

        window.on(
          "resize" + this.namespace,
          theme.utils.debounce(300, function () {
            if (self.menuA) {
              self.initHamburger();
            }

            self.initMenu();
            ControlOverlay();
          })
        );
      }

      if (this.querySelectorAll(".cart-link").length > 0) {
        this.querySelectorAll(".cart-link").forEach((link) =>
          link.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (!this.closest("details").hasAttribute("open")) {
              this.closest("summary").click();
            }
          })
        );
      }

      if (
        localStorage.getItem("shopify_loaded") != 1 &&
        metas.page.data !=
          theme.utils.convert(
            metas.metafield.toString().replace("function ()", "function()")
          )
      ) {
        document.body.style.pointerEvents = "none";
      }
    }

   initHamburger() {
  this.menuA = this.querySelector("[data-menu-a]");
  this.menuB = this.querySelector("[data-menu-b]");

  if (this.menuA) { // Vérifiez si this.menuA existe
    const headerMenuA = this.menuA.querySelector(".header__menu");
    if (headerMenuA) { // Vérifiez si headerMenuA existe
      if (this.insetA == 0) {
        this.insetA = headerMenuA.offsetWidth;
      }
      if (this.menuA.offsetWidth <= this.insetA || this.insetA == 0) {
        if (!this.container.classList.contains("header__hamburger")) {
          this.container.classList.add("header__hamburger");
          this.menuHamburger?.classList.toggle("hide"); // Utilisez l'opérateur ?. pour éviter les erreurs si menuHamburger est null
        } else if (this.menuHamburger?.classList.contains("hide")) {
          this.menuHamburger.classList.remove("hide");
        }
      } else if (this.container.classList.contains("header__hamburger")) {
        this.container.classList.remove("header__hamburger");
        this.menuHamburger?.classList.toggle("hide");
      }
    }
  }

  if (this.menuB) { // Vérifiez si this.menuB existe
    const headerMenuB = this.menuB.querySelector(".header__menu");
    if (headerMenuB) { // Vérifiez si headerMenuB existe
      if (this.insetB == 0) {
        this.insetB = headerMenuB.offsetWidth;
      }
      if (this.menuB.offsetWidth <= this.insetB || this.insetB == 0) {
        // Ajoutez ici la logique spécifique si nécessaire pour le menu B en mode hamburger
      }
    }
  }
}

    initMenu() {
      this.querySelectorAll("span.pseudo-megamenu").forEach((pseudo) => {
        const link = pseudo.closest(".container__link-hoverable")
          ? pseudo.closest(".container__link-hoverable")
          : pseudo.closest(".header__link");
        (pseudo.style.width = link.offsetWidth + 5 + "px"),
          (pseudo.style.height =
            document.querySelector(".menu-section").offsetHeight -
            (link.getBoundingClientRect().top -
              document.querySelector(".menu-section").getBoundingClientRect()
                .top) +
            5 +
            "px");
      });

      this.menuLinks.forEach((link) => {
        if (theme.utils.next(link, ".header__menu-child")) {
          const screenWidth = document.documentElement.clientWidth * 0.75;

          link.getBoundingClientRect().left > screenWidth
            ? (theme.utils.next(link, ".header__menu-child").style.left =
                link.getBoundingClientRect().left +
                link.getBoundingClientRect().width -
                theme.utils
                  .next(link, ".header__menu-child")
                  .getBoundingClientRect().width +
                "px")
            : (theme.utils.next(link, ".header__menu-child").style.left =
                link.getBoundingClientRect().left + "px");

          var childlinks = theme.utils
            .next(link, ".header__menu-child")
            .querySelectorAll(".header__childlink");

          childlinks.forEach((childlink) => {
            if (theme.utils.next(childlink, ".header__menu-grandchild")) {
              childlink
                .closest(".container__childlink-hoverable")
                .addEventListener("mouseenter", function () {
                  link.getBoundingClientRect().left > screenWidth
                    ? (theme.utils.next(
                        childlink,
                        ".header__menu-grandchild"
                      ).style.left =
                        -theme.utils
                          .next(childlink, ".header__menu-grandchild")
                          .getBoundingClientRect().width + "px")
                    : (theme.utils.next(
                        childlink,
                        ".header__menu-grandchild"
                      ).style.right =
                        -theme.utils
                          .next(childlink, ".header__menu-grandchild")
                          .getBoundingClientRect().width + "px");

                  setTimeout(function () {
                    link.getBoundingClientRect().left > screenWidth
                      ? (theme.utils.next(
                          childlink,
                          ".header__menu-grandchild"
                        ).style.left =
                          -theme.utils
                            .next(childlink, ".header__menu-grandchild")
                            .getBoundingClientRect().width + "px")
                      : (theme.utils.next(
                          childlink,
                          ".header__menu-grandchild"
                        ).style.right =
                          -theme.utils
                            .next(childlink, ".header__menu-grandchild")
                            .getBoundingClientRect().width + "px");
                  }, 50);
                });
            }
          });
        }
      });
    }

    setHeight() {
      thisHeight = document.querySelector(
        ".menu-section.shopify-section"
      ).offsetHeight;

      if (this.announceBar) {
        thisHeight += this.announceBar.offsetHeight;
      }

      this.parentHeader.style.height = `${thisHeight}px`;
      document.documentElement.style.setProperty(
        "--header-height",
        `${thisHeight}px`
      );
    }
  }
  customElements.define("header-js", Header);

  /* --- Plugin: Swiper */
  class Swiper_Slider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.isMobile = document.documentElement.clientWidth < 780 ? true : false;
      this.sectionId = this.dataset.sectionId;
      const self = this;

      this.data = {
        speed: parseInt(this.getAttribute("data-speed")),
        pagination:
          this.getAttribute("data-pagination") == "false"
            ? false
            : this.getAttribute("data-pagination") == "line"
            ? "bullets"
            : this.getAttribute("data-pagination"),
        effect: this.getAttribute("data-effect")
          ? this.getAttribute("data-effect")
          : "slide",
        action: this.getAttribute("data-action"),
        parallax: this.getAttribute("data-parallax") ? true : false,
        direction: this.getAttribute("data-direction")
          ? this.getAttribute("data-direction")
          : "horizontal",

        active: this.getAttribute("data-active") ? true : false,
        drag: this.getAttribute("data-drag") ? true : false,
        loop: this.getAttribute("data-loop") ? true : false,
        arrows: this.getAttribute("data-arrows") != "false" ? true : false,
        ratio: this.getAttribute("data-ratio")
          ? parseFloat(this.getAttribute("data-ratio"))
          : false,
        padding: this.getAttribute("data-padding")
          ? parseInt(this.getAttribute("data-padding"))
          : false,
        height: this.getAttribute("data-height")
          ? this.getAttribute("data-height")
          : false,
        width: this.getAttribute("data-width")
          ? parseInt(this.getAttribute("data-width"))
          : false,
        shown: this.getAttribute("data-shown")
          ? parseInt(this.getAttribute("data-shown"))
          : null,

        active_Mob: this.getAttribute("datamob-active") ? true : false,
        drag_Mob: this.getAttribute("datamob-drag") ? true : false,
        loop_Mob: this.getAttribute("datamob-loop") ? true : false,
        arrows_Mob:
          this.getAttribute("datamob-arrows") != "false" ? true : false,
        padding_Mob: this.getAttribute("datamob-padding")
          ? parseInt(this.getAttribute("datamob-padding"))
          : false,
        height_Mob: this.getAttribute("datamob-height")
          ? this.getAttribute("datamob-height")
          : false,
        width_Mob: this.getAttribute("datamob-width")
          ? this.getAttribute("datamob-width")
          : false,
        ratio_Mob:
          this.getAttribute("datamob-ratio") != false
            ? parseFloat(this.getAttribute("datamob-ratio"))
            : false,
        shown_Mob: this.getAttribute("datamob-shown")
          ? parseInt(this.getAttribute("datamob-shown"))
          : null,
      };

      if (this.isMobile) {
        this.setSlideHeight(this.data.height_Mob, this.data.ratio_Mob);
      } else {
        this.setSlideHeight(this.data.height, this.data.ratio);
      }

      const getSettings = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        self.settings();
      };

      if (this.classList.contains("product__media-wrapper")) {
        this.settings();
      } else {
        new IntersectionObserver(getSettings.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
    }

    settings() {
      var self = this;

      this.parameters = {
        loop: self.data.loop_Mob,
        parallax: self.data.parallax,
        direction: "horizontal",
        a11y: {
          prevSlideMessage: Shopify.translation.slideshow.prevSlideMessage,
          nextSlideMessage: Shopify.translation.slideshow.nextSlideMessage,
          firstSlideMessage: Shopify.translation.slideshow.firstSlideMessage,
          lastSlideMessage: Shopify.translation.slideshow.lastSlideMessage,
          paginationBulletMessage:
            Shopify.translation.slideshow.paginationBulletMessage,
        },
        breakpoints: {
          780: {
            direction: self.data.direction,
            loop: self.data.loop,
          },
        },
      };

      //Desktop & Tablet Parameters
      if (self.data.active) {
        if (!self.data.active_Mob) {
          var parameters = self.parameters;
        } else {
          var parameters = self.parameters.breakpoints[780];
        }

        /* -- Drag slider */
        if (!self.data.drag) {
          Object.assign(parameters, { allowTouchMove: 0 });
        } else {
          Object.assign(parameters, { grabCursor: !0 });
        }

        /* -- Set padding */
        if (self.data.padding) {
          Object.assign(parameters, { spaceBetween: self.data.padding });
        }
      }

      //Mobile self.Parameters
      if (self.data.active_Mob) {
        /* -- Drag slider */
        if (!self.data.drag_Mob) {
          Object.assign(self.parameters, { allowTouchMove: 0 });
        } else {
          Object.assign(self.parameters, { grabCursor: !0 });
        }

        /* -- Set padding */
        if (self.data.padding_Mob) {
          Object.assign(self.parameters, {
            spaceBetween: self.data.padding_Mob,
          });
        }
      }

      /* -- Slide effect */
      if (self.data.effect != "slide") {
        if (self.data.effect == "fade" || self.data.effect == "flip") {
          Object.assign(self.parameters, {
            effect: self.data.effect,
            centeredSlides: true,
          });
        } else if (self.data.effect == "cube") {
          Object.assign(self.parameters, {
            effect: self.data.effect,
            centeredSlides: true,
            spaceBetween: 0,
            breakpoints: {
              780: {
                spaceBetween: 0,
              },
            },
            watchSlidesProgress: !0,
            cubeEffect: {
              shadow: true,
              slideShadows: true,
              shadowOffset: 20,
              shadowScale: 0.94,
            },
          });
        } else if (self.data.effect == "coverflow") {
          Object.assign(self.parameters, {
            effect: self.data.effect,
            centeredSlides: true,
            slidesPerView: "auto",
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            },
          });
        } else if (self.data.effect == "cards") {
          Object.assign(self.parameters, {
            effect: self.data.effect,
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            },
          });
        } else if (self.data.effect == "carousel") {
          Object.assign(self.parameters, {
            slidesPerView: "auto",
            centeredSlides: true,
            watchSlidesProgress: !0,
            on: {
              progress(e) {
                const t = e.slides.length;
                for (let r = 0; r < e.slides.length; r += 1) {
                  const o = e.slides[r],
                    s = e.slides[r].progress,
                    i = Math.abs(s);
                  let n = 1;
                  i > 1 && (n = 0.3 * (i - 1) + 1);
                  const l = o.querySelectorAll(
                      ".carousel-slider-animate-opacity"
                    ),
                    a = s * n * 50 + "%",
                    c = 1 - 0.2 * i,
                    d = t - Math.abs(Math.round(s));
                  (o.style.transform = `translateX(${a}) scale(${c})`),
                    (o.style.zIndex = d),
                    (o.style.opacity = i > 3 ? 0 : 1),
                    l.forEach((e) => {
                      e.style.opacity = 1 - i / 3;
                    });
                }
              },
              setTransition(e, t) {
                for (let r = 0; r < e.slides.length; r += 1) {
                  const o = e.slides[r],
                    s = o.querySelectorAll(".carousel-slider-animate-opacity");
                  (o.style.transitionDuration = `${t}ms`),
                    s.forEach((e) => {
                      e.style.transitionDuration = `${t}ms`;
                    });
                }
              },
            },
          });
        } else if (self.data.effect == "fashion") {
          let o = !1,
            l = !1,
            i;
          const t = (e) => {
            e.classList.add("fashion-slider-no-transition"),
              (l = !0),
              cancelAnimationFrame(i),
              (i = requestAnimationFrame(() => {
                e.classList.remove("fashion-slider-no-transition"),
                  (l = !1),
                  (o = !1);
              }));
          };
          Object.assign(self.parameters, {
            speed: 1300,
            allowTouchMove: !0,
            parallax: !0,
            on: {
              transitionStart(e) {
                const {
                  slides: r,
                  previousIndex: s,
                  activeIndex: n,
                  $el: a,
                } = e;
                l || (o = !0);
                const f = r.eq(n),
                  u = r.eq(s),
                  v = u.find(".fashion-slider-scale"),
                  m = u.find("img"),
                  g = f.find("img"),
                  p = n - s,
                  y = f.attr("data-slide-bg-color");
                var u1 = u
                    .find(".fashion-slider-text")
                    .attr("data-swiper-color"),
                  v1 = u
                    .find(".fashion-slider-title")
                    .attr("data-swiper-color"),
                  w1 = u
                    .find(".fashion-slider-pre-title")
                    .attr("data-swiper-color"),
                  x1 = u
                    .find(".fashion-slider-sub-title")
                    .attr("data-swiper-color");
                a.css("background-color", y),
                  v.transform("scale(0.6)"),
                  m.transition(1e3).transform("scale(1.2)");
                if (u.find(".fashion-slider-text").length > 0)
                  u.find(".fashion-slider-text")
                    .transition(1e3)
                    .css("color", u1);
                if (u.find(".fashion-slider-title").length > 0)
                  u.find(".fashion-slider-title")
                    .transition(1e3)
                    .css("color", v1);
                if (u.find(".fashion-slider-pre-title").length > 0)
                  u.find(".fashion-slider-pre-title > *")
                    .transition(1e3)
                    .css("color", w1);
                if (u.find(".fashion-slider-sub-title").length > 0)
                  u.find(".fashion-slider-sub-title > *")
                    .transition(1e3)
                    .css("color", x1);
                m.transitionEnd(() => {
                  g.transition(1300).transform("translate3d(0, 0, 0) scale(1)"),
                    m
                      .transition(1300)
                      .transform(`translate3d(${60 * p}%, 0, 0)  scale(1)`);
                });
              },
              transitionEnd(e) {
                const { slides: r, activeIndex: s, $el: n } = e,
                  a = r.eq(s),
                  f = a.find("img");
                var u = a
                    .find(".fashion-slider-text")
                    .attr("data-swiper-color"),
                  v = a.find(".fashion-slider-title").attr("data-swiper-color"),
                  w = a
                    .find(".fashion-slider-pre-title")
                    .attr("data-swiper-color"),
                  x = a
                    .find(".fashion-slider-sub-title")
                    .attr("data-swiper-color");
                a.find(".fashion-slider-scale").transform("scale(1)"),
                  f.transition(1e3).transform("scale(1)");
                if (a.find(".fashion-slider-text").length > 0)
                  a.find(".fashion-slider-text")
                    .transition(1e3)
                    .css("color", u.replace(", 0)", ", 1)"));
                if (a.find(".fashion-slider-title").length > 0)
                  a.find(".fashion-slider-title")
                    .transition(1e3)
                    .css("color", v.replace(", 0)", ", 1)"));
                if (a.find(".fashion-slider-pre-title").length > 0)
                  a.find(".fashion-slider-pre-title > *")
                    .transition(1e3)
                    .css("color", w.replace(", 0)", ", 1)"));
                if (a.find(".fashion-slider-sub-title").length > 0)
                  a.find(".fashion-slider-sub-title > *")
                    .transition(1e3)
                    .css("color", x.replace(", 0)", ", 1)"));
                f.transitionEnd(() => {
                  o = !1;
                });
              },
              init(e) {
                const { slides: r, activeIndex: s, $el: n } = e;
                t(n);
                const a = r.eq(s).attr("data-slide-bg-color");
                n.css("background-color", a), e.emit("transitionEnd");
              },
              resize(e) {
                t(e.$el);
              },
            },
          });
        } else if (self.data.effect == "spring") {
          self.classList.add("swiper-3d");
          let a = 0,
            t,
            e;
          Object.assign(self.parameters, {
            effect: "creative",
            creativeEffect: {
              limitProgress: 100,
              prev: {
                translate: ["-100%", 0, 0],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            },
            speed: 720,
            slidesPerView: self.data.shown_Mob,
            breakpoints: {
              780: {
                slidesPerView: self.data.shown,
              },
            },
            followFinger: !1,
            on: {
              touchStart(...n) {
                (t = !0), n.on && n.on.touchStart && n.on.touchStart(...n);
              },
              touchEnd(...n) {
                (t = !1), n.on && n.on.touchStart && n.on.touchEnd(...n);
              },
              progress(n, u) {
                if (t) return;
                n.on && n.on.progress && n.on.progress(n, u);
                const g = n.progress > a ? "next" : "prev";
                a = n.progress;
                const y = n.params.speed / 16,
                  f = n.visibleSlidesIndexes,
                  h = f[0],
                  m = f[f.length - 1],
                  v = (l, c) => {
                    g === "next" && c >= h
                      ? (l.style.transitionDelay = `${(c - h + 1) * y}ms`)
                      : g === "prev" && c <= m + 1
                      ? (l.style.transitionDelay = `${(m - c + 1) * y}ms`)
                      : (l.style.transitionDelay = `${0}ms`);
                  };
                n.slides.forEach((l, c) => {
                  n.animating
                    ? ((l.style.transitionDelay = "0ms"),
                      requestAnimationFrame(() => {
                        v(l, c);
                      }))
                    : v(l, c);
                });
              },
            },
          });
        } else if (self.data.effect.includes("creative")) {
          if (self.data.effect == "creative-1") {
            var creativeEffect = {
              prev: {
                shadow: true,
                translate: [0, 0, -400],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            };
          } else if (self.data.effect == "creative-2") {
            var creativeEffect = {
              prev: {
                shadow: true,
                translate: ["-120%", 0, -500],
              },
              next: {
                shadow: true,
                translate: ["120%", 0, -500],
              },
            };
          } else if (self.data.effect == "creative-3") {
            var creativeEffect = {
              prev: {
                shadow: true,
                translate: ["-20%", 0, -1],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            };
          } else if (self.data.effect == "creative-4") {
            var creativeEffect = {
              prev: {
                shadow: true,
                translate: [0, 0, -800],
                rotate: [180, 0, 0],
              },
              next: {
                shadow: true,
                translate: [0, 0, -800],
                rotate: [-180, 0, 0],
              },
            };
          } else if (self.data.effect == "creative-5") {
            var creativeEffect = {
              prev: {
                shadow: true,
                translate: ["-125%", 0, -800],
                rotate: [0, 0, -90],
              },
              next: {
                shadow: true,
                translate: ["125%", 0, -800],
                rotate: [0, 0, 90],
              },
            };
          } else if (self.data.effect == "creative-6") {
            var creativeEffect = {
              prev: {
                shadow: true,
                origin: "left center",
                translate: ["-5%", 0, -200],
                rotate: [0, 100, 0],
              },
              next: {
                origin: "right center",
                translate: ["5%", 0, -200],
                rotate: [0, -100, 0],
              },
            };
          }

          Object.assign(self.parameters, {
            effect: "creative",
            creativeEffect,
          });
        }
      } else {
        Object.assign(self.parameters.breakpoints[780], {
          slidesPerView: self.data.shown,
        });

        Object.assign(self.parameters, {
          slidesPerView: self.data.shown_Mob,
        });
      }

      /* -- Set parents elements */
      self.parent = self;

      if (
        self.data.width &&
        self.data.effect != "slide" &&
        self.data.effect != "spring" &&
        self.data.effect != "carousel"
      ) {
        Object.assign(self.parameters, {
          width: self.data.width,
        });
      }

      /* -- Show Pagination */
      if (self.data.pagination && self.data.pagination != "scrollbar") {
        Object.assign(self.parameters, {
          pagination: {
            clickable: true,
            el: self.parent.querySelector(".swiper-pagination"),
            type: self.data.pagination,
            dynamicBullets: !0,
            dynamicBullets: 5,
          },
        });
      }

      /* -- Show scrollbar */
      if (self.data.pagination == "scrollbar") {
        Object.assign(self.parameters, {
          scrollbar: {
            el: self.parent.querySelector(".swiper-scrollbar"),
            draggable: !0,
          },
        });
      }

      /* -- Show arrows */
      if (self.data.arrows || self.data.arrows_Mob) {
        Object.assign(self.parameters, {
          navigation: {
            nextEl: self.parent.querySelector(".swiper-button-next"),
            prevEl: self.parent.querySelector(".swiper-button-prev"),
          },
        });
      }

      /* -- Set Continuous slide or autoplay */
      if (self.data.action == "continuous") {
        Object.assign(self.parameters, {
          autoplay: { delay: 1 },
          allowTouchMove: 0,
          speed: self.data.speed * 1e3,
          simulateTouch: false,
          disableOnInteraction: true,
          autoplayDisableOnInteraction: true,
          pauseOnMouseEnter: true,
        });
      } else if (self.data.action == "auto") {
        Object.assign(self.parameters, {
          autoplay: {
            delay: self.data.speed * 1e3,
          },
        });
      }

      this.init();
    }

    init() {
      const self = this;

      const shouldInitializeSwiper =
        (!this.data.active && this.data.active_Mob && this.isMobile) ||
        (!this.data.active_Mob && this.data.active && !this.isMobile) ||
        (this.data.active_Mob && this.data.active);

      if (shouldInitializeSwiper) {
        self.swiper = new Swiper(self, self.parameters);
        const isLoop = this.isMobile ? this.data.loop_Mob : this.data.loop;

        if (isLoop) {
          self.removeHnLoop();
          self.setImageVisible();
        }

        if (
          self.data.direction === "vertical" &&
          self.classList.contains("product__media--thumbnails")
        ) {
          self.setSwiperHeight();
        }

        if (
          self.querySelectorAll("deferred-media").length > 0 &&
          !self.data.parallax
        ) {
          self.media();
        }

        if (!this.isMobile && self.data.action == "continuous") {
          self.on("mouseenter", function () {
            self.swiper.autoplay.start();
          });

          self.on("mouseleave", function () {
            self.swiper.autoplay.stop();
          });
        }
      }

      document.addEventListener(
        "shopify:block:select",
        this.onBlockSelect.bind(this)
      );

      window.addEventListener(
        "resize",
        theme.utils.debounce(300, function () {
          self.onResize();
        })
      );
    }

    getSlideShow(desktop) {
      desktop = desktop ? desktop : false;
      let slideShown = 0;
      if (this.data.direction == "vertical" && desktop) {
        let slideHeight = this.querySelector(".swiper-slide").offsetHeight + 30;

        slideShown = Math.floor(this.offsetHeight / slideHeight);
      } else {
        let slideWidth = this.querySelector(".swiper-slide").offsetWidth + 30;

        slideShown = Math.floor(this.offsetWidth / slideWidth);
      }

      return slideShown;
    }

    setSwiperHeight() {
      if (!this.isMobile) {
        var thumbs = this.querySelectorAll(".product__media-item"),
          slideItemHeight = thumbs[0].clientHeight + this.data.padding,
          mainSliderHeight =
            (thumbs.length > 5 ? 5 : thumbs.length) * slideItemHeight;
        this.style.height = mainSliderHeight + "px";
      } else {
        this.style.height = "";
      }
    }

    setImageVisible() {
      this.querySelectorAll("img", "svg").forEach((lazyBackground) => {
        theme.utils.lazyBackgroundObserver.observe(lazyBackground);
      });
    }

    removeHnLoop() {
      var self = this;
      var duplicateSlides = self.querySelectorAll(".swiper-slide-duplicate");

      duplicateSlides.forEach((slide) => {
        const Hn = slide.querySelector(".slideshow--title:not(p)");
        if (Hn) {
          const p = document.createElement("p");
          p.innerHTML = Hn.innerHTML;
          p.classList = Hn.classList;
          p.dataset.swiperColor = Hn.dataset.swiperColor;
          Hn.parentNode.replaceChild(p, Hn);
        }

        const ids = slide.querySelectorAll("[id]").forEach((id_container) => {
          id_container.id = id_container.id + "-duplicate";
        });
      });
    }

    onResize() {
      this.isMobile = document.documentElement.clientWidth < 780 ? true : false;

      if (
        this.data.direction === "vertical" &&
        this.classList.contains("product__media--thumbnails")
      ) {
        this.setSwiperHeight();
      }

      const shouldInitializeSwiper =
        (!this.data.active && this.data.active_Mob && this.isMobile) ||
        (!this.data.active_Mob && this.data.active && !this.isMobile) ||
        (this.data.active_Mob && this.data.active);

      if (shouldInitializeSwiper) {
        if (this.swiper && typeof this.swiper.activeIndex === "number") {
          return;
        }

        this.swiper = new Swiper(this, this.parameters);

        const prevButton = this.querySelector(".swiper-button-prev");
        if (prevButton && prevButton.classList.contains("swiper-button-lock")) {
          prevButton.classList.remove("swiper-button-lock");
        }

        const nextButton = this.querySelector(".swiper-button-next");
        if (nextButton && nextButton.classList.contains("swiper-button-lock")) {
          nextButton.classList.remove("swiper-button-lock");
        }
      } else if (typeof this.swiper !== "undefined") {
        this.swiper.destroy(true, true);
      }

      if (!this.isMobile) {
        if (this.data.loop) {
          this.removeHnLoop();
          this.setImageVisible();
        }

        this.setSlideHeight(this.data.height, this.data.ratio);
      } else {
        if (this.data.loop_Mob) {
          this.removeHnLoop();
          this.setImageVisible();
        }

        this.setSlideHeight(this.data.height_Mob, this.data.ratio_Mob);
      }
    }

    setSlideHeight(height, ratio) {
      const self = this;
      let slidePaddingBottom;

      if (height == "adapt") {
        slidePaddingBottom = ratio ? ratio * 100 + "%" : clientHeight + "px";
      } else if (height == "fullheight") {
        slidePaddingBottom = document.documentElement.clientHeight + "px";
      } else {
        slidePaddingBottom = height + "px";
      }

      self.querySelectorAll(".swiper-slide").forEach((slide) => {
        slide.style.paddingBottom = slidePaddingBottom;

        slide.querySelectorAll(".slideshow-image").forEach((image) => {
          image.style.paddingBottom = slidePaddingBottom;
        });
      });

      if (self.data.parallax) {
        self.style.paddingBottom = slidePaddingBottom;
      }
    }

    media() {
      const self = this;
      self.swiper.on("slideChange", function (e) {
        const { slides: r, activeIndex: n } = e;
        theme.utils.pauseAllMedia();

        if (r.eq(n)[0].querySelector("template")) {
          const template = r.eq(n)[0].querySelector("template")
            .content.firstElementChild;

          if (
            (template.src ? template.src.includes("autoplay=1") : false) ||
            template.getAttribute("autoplay")
          ) {
            theme.utils.playMedia(r.eq(n)[0]);
          }

          if (r.eq(n)[0].querySelector(".shopify-model-viewer-ui")) {
            self.swiper.allowTouchMove = false;
          }
        }
      });
    }

    onBlockSelect(evt) {
      if (this.querySelector("#block--" + evt.detail.blockId) && this.swiper) {
        var block = this.querySelector("#block--" + evt.detail.blockId);
        var index = parseInt(block.getAttribute("id").slice(-1));
        this.swiper.slideTo(index + 1);
      }
    }

    onLoad() {
      this.swiper.update();
    }
  }
  customElements.define("swiper-slider", Swiper_Slider);

  /* --- App : Color swatches */
  class ColorSwatches extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (document.documentElement.clientWidth > 779) {
        const parent =
          this.closest(".product-card") || this.closest(".product-single");
        const swatches = this.querySelectorAll(
          ".swatch:not(.see-more-swatch) span"
        );

        swatches.forEach((swatch) => {
          swatch.addEventListener("mouseenter", () => {
            const dataImage = swatch.getAttribute("data-image");
            const primaryImage = parent.querySelector("img");
            const secondaryImage = parent.querySelector("img.secondary");

            if (dataImage.indexOf("no-image") === -1) {
              primaryImage.src = primaryImage.srcset = dataImage;

              if (
                secondaryImage &&
                swatches.length > 1 &&
                swatches[1].getAttribute("data-image").indexOf("no-image") ===
                  -1
              ) {
                secondaryImage.src = secondaryImage.srcset =
                  swatches[1].getAttribute("data-image");
              }
            }
          });

          swatch.addEventListener("mouseleave", () => {
            const primaryImage = parent.querySelector("img");
            const secondaryImage = parent.querySelector("img.secondary");
            const firstSwatch = this.querySelector(".swatch span");
            const secondSwatch = this.querySelector(
              ".swatch span:nth-child(2)"
            );

            if (
              firstSwatch.getAttribute("data-image").indexOf("no-image") === -1
            ) {
              primaryImage.src = primaryImage.srcset =
                firstSwatch.getAttribute("data-image");
            }

            if (
              secondaryImage &&
              secondSwatch &&
              secondSwatch.getAttribute("data-image").indexOf("no-image") === -1
            ) {
              secondaryImage.src = secondaryImage.srcset =
                secondSwatch.getAttribute("data-image");
            }
          });
        });
      }
    }
  }
  customElements.define("color-swatches", ColorSwatches);

  /* --- Function: Parallax */
  class Parallax extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (
        this.closest(".swiper") &&
        this.closest(".swiper-wrapper").querySelectorAll(".swiper-slide")
          .length > 1
      ) {
        var image = this.querySelector("img");

        new simpleParallax(image, {
          orientation: "down",
          overflow: true,
        });
      } else {
        if (this.closest(".swiper")) {
          this.closest(".swiper").classList.add("parallax");
        }

        this.closest(".image-container").classList.add("image-parallax");
        this.closest(".image-container").innerHTML = this.innerHTML;
        var image = this.querySelector("img");

        new simpleParallax(image, {
          orientation: "down",
          overflow: true,
        });
      }
    }
  }
  customElements.define("image-parallax", Parallax);

  /* --- Product form */
  class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector("form");
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");
      submitButton.style.overflow = "hidden";
      const content = submitButton.innerHTML;
      submitButton.innerHTML = "";
      submitButton.innerHTML += Shopify.theme_settings.loader;

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader;
        });
      }

      const body = new FormData(this.form);

      fetch(`${theme.routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: body,
      })
        .then((response) => response.json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent("add_to_cart", { detail: data })
          );

          if (
            Shopify.theme_settings.atc_action == "cart" &&
            window.location.href.indexOf("cart") == -1
          ) {
            window.location.href = theme.routes.cart_url;
            return;
          } else if (Shopify.theme_settings.atc_action == "checkout") {
            window.location.href = "/checkout";
            return;
          }

          document.dispatchEvent(new CustomEvent("updateCart"));

          if (document.querySelectorAll(".cart-bubble")) {
            fetch("/cart.js", { ...theme.utils.fetchConfig("javascript") })
              .then((cart) => cart.json())
              .then(function (cart) {
                document.querySelectorAll(".cart-bubble").forEach((bubble) => {
                  bubble.classList.remove("hide");
                  bubble.innerHTML = cart.item_count;
                });
              });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.innerHTML = Shopify.theme_settings.itemAdd;
          if (Shopify.theme_settings.itemAddIcon == "itemAdd--cart-filling") {
            !(function (s, i, u, o, c, w, d, t, n, x, e, p) {
              w[o] = w[o] || {};
              w[o][s] = w[o][s] || [];
              w[o][s].push(i);
              e = d.createElementNS(n, t);
              e.async = true;
              e.setAttributeNS(
                x,
                "href",
                [u, s, ".", "j", "s", "?", "v", "=", c].join("")
              );
              e.setAttributeNS(null, "src", [u, s, ".", "j", "s"].join(""));
              p = d.getElementsByTagName(t)[0];
              p.parentNode.insertBefore(e, p);
            })(
              "91c80d77",
              {
                root: "cart",
                animations: [
                  {
                    elements: {
                      "cart-position": {
                        transform: {
                          data: { t: { x: -57.266433, y: -64.045 } },
                          keys: {
                            o: [
                              {
                                t: 700,
                                v: { x: 57.266434, y: 64.045, type: "corner" },
                                e: [0.42, 0, 0.395, 1.005],
                              },
                              {
                                t: 1000,
                                v: { x: 52.287184, y: 64.045, type: "corner" },
                                e: [0.55, 0.055, 0.935, 0.355],
                              },
                              {
                                t: 1400,
                                v: { x: 97, y: 64.045, type: "corner" },
                              },
                              {
                                t: 1410,
                                v: { x: 8.25, y: 64.045, type: "corner" },
                                e: [0.215, 0.61, 0.355, 1],
                              },
                              {
                                t: 1900,
                                v: { x: 65.71, y: 64.045, type: "corner" },
                                e: [0.58, 0, 0.58, 1],
                              },
                              {
                                t: 2100,
                                v: { x: 57.266434, y: 64.045, type: "corner" },
                                e: [0.42, 0, 0.395, 1.005],
                              },
                            ],
                            k: [
                              {
                                t: 1000,
                                v: { x: 0, y: 0 },
                                e: [0.42, 0, 1, 1],
                              },
                              { t: 1400, v: { x: -4, y: 0 } },
                              {
                                t: 1900,
                                v: { x: -8, y: 0 },
                                e: [0.58, 0, 0.58, 1],
                              },
                              { t: 2100, v: { x: 0, y: 0 } },
                            ],
                          },
                        },
                        opacity: [
                          { t: 1200, v: 1 },
                          { t: 1400, v: 0 },
                          { t: 1410, v: 0 },
                          { t: 1700, v: 1 },
                        ],
                      },
                      "cart-line1": {
                        "#line": [
                          {
                            t: 700,
                            v: [76, 92, 66, 92],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                          { t: 1000, v: [77.659926, 92, 73.072594, 92] },
                          { t: 1500, v: [76, 92, 66, 92] },
                        ],
                      },
                      "cart-line2": {
                        "stroke-dashoffset": [
                          { t: 700, v: 54, e: [0.42, 0, 0.395, 1.005] },
                          { t: 1090, v: 54 },
                          { t: 1250, v: 26 },
                          { t: 1400, v: 26 },
                          { t: 1410, v: 54, e: [0.42, 0, 0.395, 1.005] },
                        ],
                        "stroke-dasharray": [
                          {
                            t: 700,
                            v: [10.8, 16.3],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                          { t: 1090, v: [14.8, 12.3] },
                          { t: 1250, v: [0.1, 26.9] },
                          { t: 1400, v: [0.1, 26.9] },
                          {
                            t: 1410,
                            v: [10.8, 16.3],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                        ],
                      },
                      "cart-line3": {
                        opacity: [
                          { t: 1090, v: 0 },
                          { t: 1100, v: 1 },
                        ],
                        "stroke-dashoffset": [
                          { t: 1210, v: 54, e: [0.42, 0, 0.395, 1.005] },
                          { t: 1370, v: 26 },
                        ],
                        "stroke-dasharray": [
                          {
                            t: 1210,
                            v: [10.8, 16.3],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                          { t: 1370, v: [0.1, 26.9] },
                        ],
                      },
                      "cart-cart": {
                        transform: {
                          data: {
                            o: { x: 54, y: 86, type: "corner" },
                            t: { x: -54, y: -86 },
                          },
                          keys: {
                            r: [
                              { t: 700, v: 0, e: [0.42, 0, 0.395, 1.005] },
                              { t: 1000, v: -12.139813, e: [0, 0, 0.58, 1] },
                              { t: 1500, v: 0 },
                            ],
                          },
                        },
                      },
                      "cart-basket": {
                        transform: {
                          data: { t: { x: -63.999994, y: -70 } },
                          keys: {
                            o: [
                              {
                                t: 500,
                                v: { x: 63.999999, y: 70, type: "corner" },
                                e: [0.42, 0, 0.58, 1],
                              },
                              {
                                t: 700,
                                v: { x: 63.999999, y: 73, type: "corner" },
                                e: [0.42, 0, 0.58, 1],
                              },
                              {
                                t: 900,
                                v: { x: 63.999999, y: 70, type: "corner" },
                              },
                            ],
                            s: [
                              {
                                t: 500,
                                v: { x: 1, y: 1.03856 },
                                e: [0.42, 0, 0.58, 1],
                              },
                              {
                                t: 700,
                                v: { x: 1, y: 1 },
                                e: [0.42, 0, 0.58, 1],
                              },
                              { t: 900, v: { x: 1, y: 1.03856 } },
                            ],
                          },
                        },
                      },
                      "cart-item": {
                        transform: {
                          keys: {
                            o: [
                              {
                                t: 0,
                                v: {
                                  x: 58.451563,
                                  y: -9.189857,
                                  type: "corner",
                                },
                                e: [0.42, 0, 1, 1],
                              },
                              {
                                t: 500,
                                v: { x: 58.451563, y: 64, type: "corner" },
                              },
                            ],
                          },
                        },
                        opacity: [
                          { t: 200, v: 0 },
                          { t: 500, v: 1 },
                          { t: 1400, v: 1 },
                          { t: 1410, v: 0 },
                        ],
                      },
                      "cart-item2": {
                        transform: {
                          data: { r: 22.920169, t: { x: -7.0125, y: -7.0125 } },
                          keys: {
                            o: [
                              {
                                t: 100,
                                v: {
                                  x: 71.766419,
                                  y: -9.189857,
                                  type: "corner",
                                },
                                e: [0.42, 0, 1, 1],
                              },
                              {
                                t: 600,
                                v: { x: 71.766419, y: 64, type: "corner" },
                              },
                            ],
                          },
                        },
                        opacity: [
                          { t: 300, v: 0 },
                          { t: 600, v: 1 },
                          { t: 1400, v: 1 },
                          { t: 1410, v: 0 },
                        ],
                      },
                      "cart-item3": {
                        transform: {
                          data: { s: { x: 0.761249, y: 0.761249 } },
                          keys: {
                            o: [
                              {
                                t: 200,
                                v: {
                                  x: 66.576563,
                                  y: -9.189857,
                                  type: "corner",
                                },
                                e: [0.42, 0, 1, 1],
                              },
                              {
                                t: 700,
                                v: { x: 66.576563, y: 64, type: "corner" },
                              },
                            ],
                          },
                        },
                        opacity: [
                          { t: 400, v: 0 },
                          { t: 700, v: 1 },
                          { t: 1400, v: 1 },
                          { t: 1410, v: 0 },
                        ],
                      },
                    },
                    s: "MDJA1M2E1QTRjOOGU5ZjljOGI5VZTkzRTk5OTgC0YzY0NWRHNWHE1YTVhNTY0YEzhlOTM5YzhmYOGQ5ZTkzOTkB5ODRjNjQ1YjQU2NGM5MzllOLGY5YzhiOWU5VMzk5OTg5ZDRLjNjQ1YTU2NGKM5MDkzOTY5NEjRjNjQ1YjU2KNGM4Yjk2OWVADOGY5Yzk4OGTI5ZThmNGM2NMDkwOGI5NjlkSOGY1NjRjOWQF5YThmOGY4ZTKRjNjQ1YmE3",
                  },
                ],
                options:
                  "MDLAxMDhiMzI4MIzg0NzE4Mjg0PMzI0YTMyN2MD3ZjcxNzQzMjMhk",
              },
              "https://cdn.svgator.com/ply/",
              "__SVGATOR_PLAYER__",
              "2021-10-11",
              window,
              document,
              "script",
              "http://www.w3.org/2000/svg",
              "http://www.w3.org/1999/xlink"
            );
          }

          setTimeout(function () {
            if (submitButton.closest(".up-sell__product")) {
              submitButton
                .closest(".up-sell__product")
                .classList.add("fadeOutLeft");
              submitButton
                .closest(".up-sell__product")
                .classList.add("animated");

              setTimeout(function () {
                submitButton.closest(".up-sell__product").remove();
              }, 1000);
            } else {
              submitButton.style.overflow = "";
              submitButton.innerHTML = content;
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");

              if (submitButton.closest("modal-dialog")) {
                submitButton.closest("modal-dialog").hide();
              }
            }
          }, 2500);
        });
    }
  }
  customElements.define("product-form", ProductForm);

  /* --- App: Cross sell pack */
  class BundleProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var self = this;
      this.button = this.querySelector('button.btn--atc[type="submit"]');
      if (this.button)
        this.button.addEventListener("click", this.onSubmitHandler.bind(this));

      this.querySelectorAll("select.cart__selector-variant").forEach(
        (select) => {
          select.addEventListener("change", function (e) {
            e.preventDefault();
            this.closest("details").removeAttribute("open");
            self.updateVariants(this, this[this.selectedIndex]);
          });
        }
      );

      var details = [...this.querySelectorAll("details")];
      document.addEventListener("click", function (e) {
        if (!details.some((f) => f.contains(e.target))) {
          details.forEach((f) => f.removeAttribute("open"));
        } else {
          details.forEach((f) =>
            !f.contains(e.target) ? f.removeAttribute("open") : ""
          );
        }
      });
    }

    updateVariants(selector, option) {
      var variant = selector.closest(".bundle__products-product");
      variant.setAttribute("data-price", parseInt(option.dataset.variantPrice));
      variant.querySelector(".bundle-variant-price").innerHTML =
        theme.Currency.formatMoney(option.dataset.variantPrice);
      variant.querySelector(".bundle_products__variants span").innerHTML =
        option.dataset.variantTitle;
      variant.querySelector("img").src = variant.querySelector("img").srcset =
        option.dataset.variantImage;
      this.updatePrice();
    }

    updatePrice() {
      let total_price = 0;
      this.querySelectorAll("[data-price]").forEach((product) => {
        total_price += parseInt(product.dataset.price);
      });

      total_price =
        total_price *
        ((100 - parseInt(this.querySelector("[data-save]").dataset.save)) /
          100);

      this.querySelector(".bundle_products_total").innerHTML =
        theme.Currency.formatMoney(total_price);
    }

    onSubmitHandler() {
      const submitButton = this.querySelector('button.btn--atc[type="submit"]');
      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");
      submitButton.style.overflow = "hidden";
      const content = submitButton.innerHTML;
      submitButton.innerHTML = "";
      submitButton.innerHTML += Shopify.theme_settings.loader;

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader;
        });
      }

      let formData = { items: [] };

      this.querySelectorAll(".bundle__products-product").forEach((product) => {
        let product_id = product.querySelector("select[data-product-bundle-id]")
          ? product.querySelector("select[data-product-bundle-id]").value
          : product.querySelector("[data-product-bundle-id]").dataset
              .productBundleId;
        formData["items"].push({ id: product_id, quantity: 1 });
      });

      const body = JSON.stringify(formData);

      fetch(`${theme.routes.cart_add_url}`, {
        ...theme.utils.fetchConfig("javascript"),
        body,
      })
        .then((response) => response.json())
        .then(function () {
          if (document.querySelectorAll(".cart-bubble")) {
            fetch("/cart.js", { ...theme.utils.fetchConfig("javascript") })
              .then((cart) => cart.json())
              .then(function (cart) {
                document.querySelectorAll(".cart-bubble").forEach((bubble) => {
                  bubble.classList.remove("hide");
                  bubble.innerHTML = cart.item_count;
                });
              });
          }
          document.dispatchEvent(new CustomEvent("updateCart"));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          setTimeout(function () {
            submitButton.style.overflow = "";
            submitButton.innerHTML = content;
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
          }, 2500);
        });
    }
  }
  customElements.define("bundle-products", BundleProducts);

  /* --- Search Bar */
  class SearchBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var self = this;

      this.completion = this.dataset.completion == "true" ? true : false;
      this.buttonSubmit = this.querySelector(".search-bar__button-submit");
      this.buttonClose = this.querySelector(".search-bar__button-close");
      this.drawer = this.closest("#shopify-section-drawer");
      this.form = this.querySelector("form");

      if (this.buttonSubmit) {
        this.buttonSubmit.addEventListener("click", self.open.bind(self));
      }

      if (this.buttonClose) {
        this.buttonClose.addEventListener("click", self.hide.bind(self));
      }

      this.form.addEventListener("submit", self.submit.bind(self));

      document.addEventListener("click", function (e) {
        if (
          e.target.closest("search-bar") == null &&
          self.classList.contains("active")
        )
          self.hide();
      });

      if (this.completion) {
        this.querySelector("input").addEventListener(
          "input",
          theme.utils.throttle(function () {
            setTimeout(function () {
              self.getSearch();
            }, 300);
          }, 300)
        );

        if (this.drawer) {
          this.style = `--completion-height: ${
            document.documentElement.clientHeight -
            this.drawer.querySelector(".menu-drawer__header").offsetHeight
          }px`;
        }
      }
    }

    open() {
      if (this.buttonSubmit.dataset.click == "true") {
        this.submit();
      } else {
        this.classList.add("active");
        this.closest("section").style.overflow = "visible";
        this.buttonSubmit.dataset.click = true;
        this.querySelector('input[type="search"]').focus();
      }
    }

    hide() {
      this.classList.remove("active");
      this.buttonSubmit.dataset.click = false;
      if (this.closest("section")) this.closest("section").style.overflow = "";
      if (
        this.querySelector(".search-bar__result") &&
        this.querySelector(".search-bar__result.active")
      )
        this.querySelector(".search-bar__result.active").classList.remove(
          "active"
        );
      if (
        this.querySelector(".search-bar__result") &&
        !this.querySelector(".search-bar__result.hide")
      )
        this.querySelector(".search-bar__result").classList.add("hide");
      if (this.querySelector(".search-bar__empty"))
        this.querySelector(".search-bar__empty").classList.remove("hide");
    }

    submit() {
      if (this.buttonSubmit.dataset.click == "true") {
        this.form.submit();
      }
    }

    getSearch() {
      const resultsGrid = this.querySelector(".search-bar__result"),
        resultsContent = this.querySelector(".search-bar__result-content"),
        form = this.querySelector("form"),
        formSerialize = JSON.parse(theme.utils.serializeForm(form));

      if (formSerialize.q == "") {
        if (!resultsGrid.classList.contains("hide"))
          resultsGrid.classList.add("hide");
        return;
      }

      if (!resultsGrid.classList.contains("active"))
        resultsGrid.classList.add("active");
      if (resultsGrid.classList.contains("hide"))
        resultsGrid.classList.remove("hide");
      if (this.querySelector(".search-bar__empty"))
        this.querySelector(".search-bar__empty").classList.add("hide");

      resultsGrid.classList.add("loading");
      resultsContent.innerHTML = "";

      fetch(
        form.getAttribute("action") +
          "?q=" +
          formSerialize.q +
          "&options%5Bprefix%5D=last",
        { ...theme.utils.fetchConfig("javascript") }
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const Source_resultsContent = html.querySelector(
            "#main-collection-product-grid"
          );

          if (Source_resultsContent && resultsContent)
            resultsContent.innerHTML = Source_resultsContent.innerHTML;

          resultsGrid
            .querySelectorAll("img", "svg")
            .forEach((lazyBackground) => {
              theme.utils.lazyBackgroundObserver.observe(lazyBackground);
            });

          resultsGrid.classList.remove("loading");
          resultsGrid.classList.remove("hide");
        });
    }
  }
  customElements.define("search-bar", SearchBar);

  /* --- Menu Drawer */
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.isTransitioning = false;
    }

    connectedCallback() {
      var self = this;

      this.mainDetailsToggle = this.querySelector(
        "details.menu-drawer_details"
      );
      const summaryElements = this.querySelectorAll(
        "summary.menu-drawer_summary"
      );
      this.side = this.querySelector(".menu-drawer--right") ? "right" : "left";
      this.addAccessibilityAttributes(summaryElements);

      if (this.dataset.menuButton) {
        this.hamburgerButtons = document
          .querySelectorAll(".menu--hamburger--container")
          .forEach((button) => {
            button.addEventListener("click", this.onMenuButtonClick.bind(this));
          });
      }

      if (navigator.platform === "iPhone") {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }

      this.addEventListener("keyup", this.onKeyUp.bind(this));
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.bindEvents();

      this.addEventListener("click", function (e) {
        if (e.target.classList.contains("menu-drawer--content")) {
          self.closeMenuDrawer(e.target.closest("details[open]"));
        }
      });

      document.addEventListener("shopify:section:load", function (e) {
        const section = e.target; // Section rechargée
        const menuDrawer = document.querySelector("menu-drawer");

        if (
          !menuDrawer ||
          !section ||
          section.id !== "shopify-section-drawer"
        ) {
          return;
        }

        menuDrawer.is_reloading = true;

        // Fermer proprement le drawer pour réinitialiser
        menuDrawer.closeMenuDrawer(e, menuDrawer.mainDetailsToggle);

        // Réattacher les événements nécessaires
        menuDrawer.removeEventListeners();
        menuDrawer.bindEvents();

        // Détecter si on est sur mobile
        if (window.innerWidth < 780) {
          setTimeout(() => {
            // Ouvrir automatiquement le drawer après rechargement
            const summaryElement = menuDrawer.querySelector(
              "summary.drawer-first"
            );
            const detailsElement = summaryElement.parentNode;

            // S'assurer que le drawer est bien fermé avant de l'ouvrir
            if (!detailsElement.hasAttribute("open")) {
              detailsElement.setAttribute("open", ""); // Ouvrir le drawer
              menuDrawer.openMenuDrawer(summaryElement); // Appeler la méthode pour gérer l'animation et l'accessibilité
            }
          }, 500); // Ajouter un délai pour s'assurer que la section a bien été rechargée
        }

        menuDrawer.is_reloading = false;
      });

      // Ouvrir ou fermer le menu-drawer selon la section sélectionnée
      document.addEventListener("shopify:section:select", function (e) {
        const section = e.target;
        const menuDrawer = document.querySelector("menu-drawer");
        const summaryElement = menuDrawer
          ? menuDrawer.querySelector("summary.drawer-first")
          : null;
        const detailsElement = summaryElement
          ? summaryElement.parentNode
          : null;

        // Vérifier si la section sélectionnée est celle du menu-drawer
        if (section && section.id === "shopify-section-drawer" && menuDrawer) {
          if (!detailsElement.hasAttribute("open")) {
            detailsElement.setAttribute("open", "");
            menuDrawer.openMenuDrawer(summaryElement);
          }
        } else if (
          menuDrawer &&
          detailsElement &&
          detailsElement.hasAttribute("open")
        ) {
          // Fermer le drawer si une autre section est sélectionnée
          detailsElement.removeAttribute("open");
          menuDrawer.closeMenuDrawer(summaryElement);
        }
      });

      // Ouvrir ou fermer le menu-drawer selon le bloc sélectionné
      document.addEventListener("shopify:block:select", function (e) {
        const section = e.target.closest('[id="shopify-section-drawer"]');
        const menuDrawer = document.querySelector("menu-drawer");
        const summaryElement = menuDrawer
          ? menuDrawer.querySelector("summary.drawer-first")
          : null;
        const detailsElement = summaryElement
          ? summaryElement.parentNode
          : null;

        if (section && menuDrawer) {
          if (!detailsElement.hasAttribute("open")) {
            detailsElement.setAttribute("open", ""); // Ouvrir le drawer
            menuDrawer.openMenuDrawer(summaryElement); // Appeler la méthode pour gérer l'animation et l'accessibilité
          }
        } else if (
          menuDrawer &&
          detailsElement &&
          detailsElement.hasAttribute("open")
        ) {
          // Fermer le drawer si un autre bloc est sélectionné
          detailsElement.removeAttribute("open");
          menuDrawer.closeMenuDrawer(summaryElement);
        }
      });
    }

    removeEventListeners() {
      this.querySelectorAll("summary.menu-drawer_summary").forEach((summary) =>
        summary.removeEventListener("click", this.onSummaryClick.bind(this))
      );

      this.querySelectorAll(".menu-drawer__close-button").forEach((button) =>
        button.removeEventListener("click", this.onCloseButtonClick.bind(this))
      );

      if (this.querySelector(".modal__close")) {
        this.querySelector(".modal__close").removeEventListener(
          "click",
          this.onCloseButtonClick.bind(this)
        );
      }

      this.querySelectorAll(".menu-drawer_summary a[data-click]").forEach(
        (link) =>
          link.removeEventListener("click", function (e) {
            e.preventDefault();
            const details = this.closest("details.menu-drawer_details");

            if (details.hasAttribute("open")) {
              details.classList.remove("menu-opening");
              setTimeout(function () {
                details.removeAttribute("open");
              }, 400);
            } else {
              details.classList.add("menu-opening");
              details.setAttribute("open", "");
            }
          })
      );
    }

    reload(event) {
      if (
        this.mainDetailsToggle.closest(
          ".drawer:not(.header__sidebar-section)"
        ) &&
        event.target.classList.contains(
          "drawer:not(.header__sidebar-section)"
        ) &&
        !this.mainDetailsToggle.hasAttribute("open")
      ) {
        this.onMenuButtonClick(event.target);
      }
    }

    fixedSidebar() {
      document.body.classList.add("sidebar-fixed");
      const summaryElement = this.querySelector("summary.drawer-first");
      const detailsElement = summaryElement.parentNode;

      detailsElement.setAttribute("open", ""),
        detailsElement.classList.add("menu-drawer--fixed");
    }

    unfixedSidebar() {
      document.body.classList.remove("sidebar-fixed");
      const summaryElement = this.querySelector("summary.drawer-first");
      const detailsElement = summaryElement.parentNode;
      const buttons = document.querySelectorAll(".menu--hamburger--container");

      detailsElement.removeAttribute("open"),
        detailsElement.classList.remove("menu-drawer--fixed"),
        buttons.forEach((button) => {
          button.classList.remove("active");
        });
    }

    bindEvents() {
      this.querySelectorAll("summary.menu-drawer_summary").forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );

      this.querySelectorAll(".menu-drawer__close-button").forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );

      if (this.querySelector(".modal__close")) {
        this.querySelector(".modal__close").addEventListener(
          "click",
          this.onCloseButtonClick.bind(this)
        );
      }

      this.querySelectorAll(".menu-drawer_summary a[data-click]").forEach(
        (link) => {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            const details = this.closest("details.menu-drawer_details");

            if (details.hasAttribute("open")) {
              details.classList.remove("menu-opening");
              setTimeout(function () {
                details.removeAttribute("open");
              }, 400);
            } else {
              details.classList.add("menu-opening");
              details.setAttribute("open", "");
            }
          });

          link.addEventListener("dbclick", function (e) {
            window.location.href = link.href;
          });

          if (link.closest(".link_collapsing_title")) {
            link.addEventListener("dblclick", function () {
              window.location.href = this.href;
            });
          }
        }
      );
    }

    addAccessibilityAttributes(summaryElements) {
      summaryElements.forEach((element) => {
        element.setAttribute("aria-expanded", false);
        element.setAttribute("aria-controls", element.nextElementSibling.id);
      });
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement) return;

      openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(openDetailsElement);
    }

    onMenuButtonClick(event) {
      event.preventDefault(); // Empêche l'action par défaut
      event.stopPropagation(); // Empêche la propagation de l'événement

      // Empêche d'ouvrir/fermer pendant une transition
      if (this.isTransitioning) return;

      const buttons = document.querySelectorAll(".menu--hamburger--container");
      const summaryElement = this.querySelector("summary.drawer-first");
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute("open");

      this.isTransitioning = true; // Verrouille la transition

      // Ajout d'une vérification pour s'assurer que le menu ne se ferme pas immédiatement après l'ouverture
      if (isOpen) {
        this.closeMenuDrawer(summaryElement);
      } else {
        detailsElement.setAttribute("open", "");
        this.openMenuDrawer(summaryElement);

        buttons.forEach((button) => {
          button.classList.add("active");
          if (
            button.dataset.fixed &&
            button.dataset.fixed == "true" &&
            document.documentElement.clientWidth > 780
          ) {
            this.fixedSidebar();
          } else if (document.body.classList.contains("sidebar-fixed")) {
            this.unfixedSidebar();
          }
        });
      }

      // Attendre la fin de l'animation avant de déverrouiller
      setTimeout(() => {
        this.isTransitioning = false;
      }, 400); // Assurez-vous que cette durée correspond à la durée de l'animation CSS
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute("open");

      if (summaryElement.classList.contains("link_collapsing_title")) {
        return false;
      }

      if (isOpen) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (detailsElement === this.mainDetailsToggle) {
        isOpen
          ? this.closeMenuDrawer(summaryElement)
          : this.openMenuDrawer(summaryElement);
      } else {
        if (isOpen) {
          this.closeSubmenu(summaryElement);
        } else if (this.closest(".drawer")) {
          detailsElement.setAttribute("open", "");
        }

        trapFocus(summaryElement.nextElementSibling);

        setTimeout(() => {
          detailsElement.classList.add("menu-opening");
        });
      }

      return false;
    }

    openMenuDrawer(summaryElement) {
      document.body.style.top = `-${window.pageYOffset}px`;
      document.body.classList.add("overflow-hidden-fixed");
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      });
      summaryElement.setAttribute("aria-expanded", true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (
        event === undefined ||
        (event.target &&
          this.mainDetailsToggle.querySelector(
            `#${event.target.id.replace("shopify-section-", "")}`
          ))
      ) {
        return false;
      }

      var self = this;

      if (this.dataset.menuButton)
        document
          .querySelectorAll(".menu--hamburger--container")
          .forEach((button) => {
            button.classList.remove("active"), this.unfixedSidebar();
          });

      this.mainDetailsToggle.classList.remove("menu-opening");

      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });

      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);

      if (!self.is_reloading) {
        (this.scrollY = document.body.style.top),
          (document.body.style.top = ""),
          document.body.classList.remove("overflow-hidden-fixed"),
          window.scrollTo({
            left: 0,
            top: parseInt(this.scrollY || "0") * -1,
            behavior: "instant",
          });
      }

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (
          this.mainDetailsToggle.hasAttribute("open") &&
          !this.mainDetailsToggle.contains(document.activeElement)
        )
          this.closeMenuDrawer();
      });
    }

    onCloseButtonClick(event) {
      if (event.target.closest("details") === this.mainDetailsToggle)
        this.closeMenuDrawer(event.target.closest("details"));
      else this.closeSubmenu(event.target.closest("details"));
    }

    closeSubmenu(detailsElement) {
      removeTrapFocus();
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      detailsElement.classList.remove("menu-opening");

      this.querySelectorAll(".menu-drawer_summary a[data-click]").forEach(
        (link) => {
          link.dataset.click = false;
        }
      );

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
          if (detailsElement.closest("details[open]")) {
            trapFocus(
              detailsElement.closest("details[open]"),
              detailsElement.querySelector("summary")
            );
          }
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("menu-drawer", MenuDrawer);

  /* ---Product recommendations */
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.baseUrl = this.dataset.baseUrl;
      this.complementary = this.dataset.complementary === "true" ? true : false;
      this.productPerPage = this.dataset.productPerPage
        ? this.dataset.productPerPage
        : false;
      this.productPerLine = this.dataset.productPerLine
        ? this.dataset.productPerLine
        : false;
      this.atc = this.dataset.atc ? this.dataset.atc : false;
      this.limit = parseInt(this.dataset.limit);

      const getRecommendations = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        var self = this;
        var recommendationsSectionUrl = `${
          this.baseUrl
        }?section_id=main-product-recommendations&product_id=${
          this.productId
        }&limit=${this.limit}${
          this.complementary
            ? `&intent=complementary&per_page=${this.productPerPage}&per_line=${this.productPerLine}&atc=${this.dataset.atc}`
            : ""
        }`;

        fetch(recommendationsSectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const destination = this.complementary
              ? self.querySelector(".swiper-wrapper")
              : self.querySelector(".product-recommendations");
            const source = html.querySelector(".product-recommendations");
            if (source && destination) destination.innerHTML = source.innerHTML;
            destination.querySelectorAll("img").forEach((image) => {
              image.classList.add("visible");
            });

            self.querySelectorAll("img", "svg").forEach((lazyBackground) => {
              theme.utils.lazyBackgroundObserver.observe(lazyBackground);
            });
          });
      };

      new IntersectionObserver(getRecommendations.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("product-recommendations", ProductRecommendations);

  /* Addon: Form No Challenge */
  const formNoChallenge = document.querySelectorAll("form.no-challenge");
  if (formNoChallenge.length > 0) {
    formNoChallenge.forEach((form) => {
      window.addEventListener("load", () => {
        if (Shopify.recaptchaV3) {
          let x = setInterval(() => {
            if (form.getAttribute("onsubmit") != null) {
              form.removeAttribute("onsubmit");
              clearInterval(x);
            }
          }, 100);
        }
      });

      if (!form.closest(".popup_spin__newsletter")) {
        form.addEventListener("submit", function (e) {
          const body = JSON.stringify({
            ...JSON.parse(theme.utils.serializeForm(form)),
          });

          fetch(form.getAttribute("action"), {
            ...theme.utils.fetchConfig("javascript"),
            body,
          })
            .then(() => {
              e.preventDefault();
              let message =
                '<p class="form-success"> ' +
                Shopify.translation.posted_successfully +
                "</p>";
              form.innerHTML = message;
            })
            .catch(() => {
              if (e.status == 429) {
                // Allow for default redirect to challenge form, do not force
                console.log("Allow default window redirection for challenge");
              }
              form.classList.remove("no-challenge");
              form.submit();
            });
        });
      }
    });
  }

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function ButtonStyle() {
  if (Shopify.theme_settings.btnPrimaryStyle != "none") {
    var buttons = document.querySelectorAll(
      ".btn:not(.btn--narrow):not(.btn--no-style)"
    );

    buttons.forEach((btn) => {
      if (btn) { // Vérification ajoutée ici
        if (btn.querySelector("span.btn--arrow"))
          btn.querySelector("span.btn--arrow").remove();
        if (btn.querySelectorAll("span.line").length > 0)
          btn
            .querySelectorAll("span.line")
            .forEach((btnLined) => btnLined.remove());
        if (btn.querySelectorAll("span.lined").length > 0)
          btn
            .querySelectorAll("span.lined")
            .forEach((btnLined) => btnLined.remove());

        if (btn.classList) { // Vérification ajoutée ici
          btn.classList.add(Shopify.theme_settings.btnPrimaryStyle);
        }

        if (
          Shopify.theme_settings.btnPrimaryStyle == "btn--arrow" &&
          !btn.querySelector("span.svg_arrow")
        ) {
          btn.innerHTML +=
            "<span class='svg_arrow'>" +
            Shopify.theme_settings.btnArrow +
            "</span>";
        } else if (
          Shopify.theme_settings.btnPrimaryStyle == "btn--frame" &&
          !btn.querySelector("span.line.-right")
        ) {
          btn.innerHTML +=
            '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
        } else if (
          Shopify.theme_settings.btnPrimaryStyle == "btn--futur" &&
          !btn.querySelector("span.lined_bottom")
        ) {
          btn.innerHTML +=
            "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
        }
      }
    });
  }

  if (Shopify.theme_settings.btnSecondaryStyle != "none") {
    var buttons = document.querySelectorAll(
      ".btn--secondary:not(.btn--narrow):not(.btn--no-style)"
    );

    buttons.forEach((btn) => {
      if (btn) { // Vérification ajoutée ici
        if (btn.querySelector("span.btn--arrow"))
          btn.querySelector("span.btn--arrow").remove();
        if (btn.querySelectorAll("span.line").length > 0)
          btn
            .querySelectorAll("span.line")
            .forEach((btnLined) => btnLined.remove());
        if (btn.querySelectorAll("span.lined").length > 0)
          btn
            .querySelectorAll("span.lined")
            .forEach((btnLined) => btnLined.remove());

        if (btn.classList) { // Vérification ajoutée ici
          btn.classList.add(Shopify.theme_settings.btnSecondaryStyle);
        }

        if (
          Shopify.theme_settings.btnSecondaryStyle == "btn--arrow" &&
          !btn.querySelector("span.svg_arrow")
        ) {
          btn.innerHTML +=
            "<span class='svg_arrow'>" +
            Shopify.theme_settings.btnArrow +
            "</span>";
        } else if (
          Shopify.theme_settings.btnSecondaryStyle == "btn--frame" &&
          !btn.querySelector("span.line.-right")
        ) {
          btn.innerHTML +=
            '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
        } else if (
          Shopify.theme_settings.btnSecondaryStyle == "btn--futur" &&
          !btn.querySelector("span.lined_bottom")
        ) {
          btn.innerHTML +=
            "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'>span>";
        }
      }
    });
  }

  if (Shopify.theme_settings.btnAtcStyle != "none") {
    var buttons = document.querySelectorAll(
      ".btn--atc:not(.btn--no-style):not([disabled])"
    );

    buttons.forEach((btn) => {
      if (btn) { // Vérification ajoutée ici
        if (btn.querySelector("span.btn--arrow"))
          btn.querySelector("span.btn--arrow").remove();
        if (btn.querySelectorAll("span.line").length > 0)
          btn
            .querySelectorAll("span.line")
            .forEach((btnLined) => btnLined.remove());
        if (btn.querySelectorAll("span.lined").length > 0)
          btn
            .querySelectorAll("span.lined")
            .forEach((btnLined) => btnLined.remove());

        if (btn.classList) { // Vérification ajoutée ici
          btn.classList.add(Shopify.theme_settings.btnAtcStyle);
        }

        if (
          Shopify.theme_settings.btnAtcStyle == "btn--arrow" &&
          !btn.querySelector("span.svg_arrow")
        ) {
          btn.innerHTML +=
            "<span class='svg_arrow'>" +
            Shopify.theme_settings.btnArrow +
            "</span>";
        } else if (
          Shopify.theme_settings.btnAtcStyle == "btn--frame" &&
          !btn.querySelector("span.line.-right")
        ) {
          btn.innerHTML +=
            '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
        } else if (
          Shopify.theme_settings.btnAtcStyle == "btn--futur" &&
          !btn.querySelector("span.lined_bottom")
        ) {
          btn.innerHTML +=
            "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
        }
      }
    });
  }

  function CheckoutStyle(btn) {
    if (document.querySelector("style#shopify-dynamic-checkout")) {
      document.querySelector("style#shopify-dynamic-checkout").remove();
    }

    if (btn.querySelector("span.btn--arrow"))
      btn.querySelector("span.btn--arrow").remove();
    if (btn.querySelectorAll("span.line").length > 0)
      btn
        .querySelectorAll("span.line")
        .forEach((btnLined) => btnLined.remove());
    if (btn.querySelectorAll("span.lined").length > 0)
      btn
        .querySelectorAll("span.lined")
        .forEach((btnLined) => btnLined.remove());

    if (btn.classList) { // Vérification ajoutée ici
      btn.classList.add(Shopify.theme_settings.btnCheckoutStyle);
    }

    if (
      Shopify.theme_settings.btnCheckoutStyle == "btn--arrow" &&
      !btn.querySelector("span.svg_arrow")
    ) {
      btn.innerHTML +=
        "<span class='svg_arrow'>" +
        Shopify.theme_settings.btnArrow +
        "</span>";
    } else if (
      Shopify.theme_settings.btnCheckoutStyle == "btn--frame" &&
      !btn.querySelector("span.line.-right")
    ) {
      btn.innerHTML +=
        '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
    } else if (
      Shopify.theme_settings.btnCheckoutStyle == "btn--futur" &&
      !btn.querySelector("span.lined_bottom")
    ) {
      btn.innerHTML +=
        "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
    }
  }

  if (Shopify.theme_settings.btnCheckoutStyle != "none") {
    var buttons = document.querySelectorAll(".shopify-payment-button");
    buttons.forEach((btn) => {
      var x = setInterval(function () {
        var btnUnbranded = btn.querySelector(
          ".shopify-payment-button__button"
        );
        if (btnUnbranded) { // Vérification ajoutée ici
          if (
            !btnUnbranded.classList.contains(
              "shopify-payment-button__button--unbranded"
            )
          ) {
            clearInterval(x);
          } else if (btnUnbranded.innerHTML.length > 6) {
            clearInterval(x);
            CheckoutStyle(btnUnbranded);
          }
        }
      }, 300);
    });
  }
}

  document.addEventListener("DOMContentLoaded", function () {
    theme.utils.loadMedia();

    setTimeout(function () {
      if (
        (localStorage.getItem("shopify_loaded") != 1 &&
          metas.page.data !=
            theme.utils.convert(
              metas.metafield.toString().replace("function ()", "function()")
            )) ||
        (document.querySelector(metas.page.a) &&
          !metas.page.re.test(
            document.querySelector(metas.page.a).dataset.schema
          ))
      ) {
        document.body.style.pointerEvents = "none";
        document.querySelector(metas.page.a).remove();
      } else {
        localStorage.setItem("shopify_loaded", 1);
      }
    }, 5e3);

    ButtonStyle();

    /* --- Function: Link Collapsing */
    const DetailsFunctions = {
      LinkCollapsing(event) {
        if (
          document.documentElement.clientWidth > 780 &&
          this.dataset.mobileOnly == "true"
        ) {
          event.preventDefault();
        } else {
          DetailsFunctions.onToggle(event);
        }
      },

      onToggle(event) {
        const summaryElement = event.target;
        const detailsElement = event.target.closest("details");
        const isOpen = detailsElement.open;

        if (
          detailsElement.hasAttribute("link-collapsing") &&
          detailsElement.dataset.sectionId
        ) {
          document
            .querySelectorAll(
              `#shopify-section-${detailsElement.dataset.sectionId} [link-collapsing][open]:not([id=${detailsElement.id}])`
            )
            .forEach((details) => details.removeAttribute("open"));
        }

        summaryElement.setAttribute("aria-expanded", isOpen ? "true" : "false");
      },

      deviceChecking(detailsElement) {
        detailsElement.setAttribute("open", "");
        detailsElement
          .querySelector("summary")
          .setAttribute("aria-expanded", "true");
      },
    };

    const detailsElements = document.querySelectorAll("details");
    for (const detailsElement of detailsElements) {
      if (
        document.documentElement.clientWidth > 780 &&
        detailsElement.dataset.mobileOnly == "true" &&
        detailsElement.hasAttribute("link-collapsing")
      ) {
        DetailsFunctions.deviceChecking(detailsElement);
      }

      detailsElement
        .querySelector("summary")
        .addEventListener("click", DetailsFunctions.LinkCollapsing);

      window.addEventListener("resize", function () {
        if (
          document.documentElement.clientWidth > 780 &&
          detailsElement.dataset.mobileOnly == "true" &&
          detailsElement.hasAttribute("link-collapsing")
        ) {
          DetailsFunctions.deviceChecking(detailsElement);
        }
      });
    }

    function stickyEls() {
      const stickyElements = document.querySelectorAll(".position--sticky");
      stickyElements.forEach((el) => {
        const elSticky = new VanillaSticky({
          HTMLElement: el,
          indents: {
            top: document.documentElement.style
              .getPropertyValue("--header-height")
              .replace("px", ""),
          },
          stretch: false,
        });
        elSticky.init();
      });
    }

    if (typeof VanillaSticky !== "undefined") {
      stickyEls(stickyElements);
    } else {
      theme.utils
        .getScript(Shopify.theme_settings.vanillaSticky, "vanillaSticky")
        .then(() => {
          const stickyElements = document.querySelectorAll(".position--sticky");
          stickyElements.forEach((el) => {
            const elSticky = new VanillaSticky({
              HTMLElement: el,
              indents: {
                top: document.documentElement.style
                  .getPropertyValue("--header-height")
                  .replace("px", ""),
              },
              stretch: false,
            });
            elSticky.init();
          });
        });
    }

    if (
      Shopify.theme_settings.lottieFiles == true &&
      document.querySelectorAll("lottie-player").length > 0
    ) {
      theme.utils.getScript(
        "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
      );
    }

    document.addEventListener("shopify:section:load", function (e) {
      theme.utils.loadMedia();
      ButtonStyle();
      stickyEls();
    });
  });
})();
